module.exports = __webpack_public_path__ + "static/media/circuit.2505d17c.gif";